import type { ReactNode } from "react";

type InfoBoxProps = {
  title: string;
  children: ReactNode;
};

export function InfoBox({ title, children }: InfoBoxProps) {
  return (
    <aside className="info-box">
      <strong className="info-box__title">{title}</strong>
      <div className="info-box__content">{children}</div>
    </aside>
  );
}
